import { useRef, useState } from "react";
import boy from "../../../assets/png/male-teacher-profile.png";
import AddUserModal from "../../../components/Accesses/AccesseModal/AddUserModal";
import AccessesControl from "../../../components/Accesses/AccessesControl/AccessesControl";
import AccessesTable from "../../../components/Accesses/AccessesTable/AccessesTable";
import { accessesTableUsers as initUsers } from "../../../misc/constants";
import { User } from "../../../misc/types";

export default function Accesses() {
  const usersListRef = useRef<HTMLDivElement>(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [accessesTableUsers, setAccessesTableUsers] =
    useState<User[]>(initUsers);
  const [isChangeTable, setIsChangeTable] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const addUser = (email: string) => {
    const newUser: User = {
      accesses: {
        events: {
          create: false,
          confirm: false,
        },

        smartroom: {
          access: false,
        },

        news: {
          create: false,
          confirm: false,
        },

        organizations: {
          control: false,
        },

        descs: {
          control: false,
        },

        mentors: {
          control: false,
        },

        cabinets: {
          control: false,
        },

        delete: {
          delete: "",
        },
      },
      email: email,
      img: boy,
      name: "",
    };
    const users = [...accessesTableUsers];
    users.push(newUser);
    setAccessesTableUsers(users);
    setIsAddModalOpen(false);
  };

  const deleteUser = (email: string) => {
    const filteredUsers = accessesTableUsers.filter(
      (user) => user.email !== email
    );
    setAccessesTableUsers(filteredUsers);
  };

  const updateUserAccesses = (
    email: string,
    updatedAccesses: User["accesses"]
  ) => {
    setAccessesTableUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.email === email ? { ...user, accesses: updatedAccesses } : user
      )
    );
  };
  const filteredUsers = accessesTableUsers.filter(
    (user) =>
      user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      className="text-black bg-white m-8 rounded-xl px-2 py-4 h-[85vh] flex flex-col w-full max-w-[clamp(650px,80vw,1750px)]"
      ref={usersListRef}
    >
      <AccessesControl
        setIsAddModalOpen={setIsAddModalOpen}
        setIsChangeTable={setIsChangeTable}
        buttonText={isChangeTable ? "Сохранить" : "Редактировать права"}
        setSearchQuery={setSearchQuery}
      />
      <AccessesTable
        accessesTableUsers={filteredUsers}
        deleteUser={deleteUser}
        isChangeTable={isChangeTable}
        updateUserAccesses={updateUserAccesses}
        usersListRef={usersListRef}
      />

      {isAddModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
          <AddUserModal
            setIsAddModalOpen={setIsAddModalOpen}
            addUser={addUser}
          />
        </div>
      )}
    </div>
  );
}
